import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const Person = ({
  width = '20',
  height = '23',
  color = '#96A2C2'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    style={{
      fill: color,
      width: width,
      height: height
    }}
    viewBox="-3 1 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 5.33325C15 8.09575 12.7617 10.3333 10 10.3333C7.23833 10.3333 5 8.09575 5 5.33325C5 2.57075 7.23833 0.333252 10 0.333252C12.7608 0.333252 15 2.57159 15 5.33325ZM20 18.6666C20 18.6666 17.1783 12.8783 9.94583 12.8783C2.71333 12.8783 0 18.6666 0 18.6666V22.8333H20V18.6666Z" />
  </IconSvg>
)

export default Person
